import { render } from "./TarjetaEdicionEmpresa.vue?vue&type=template&id=02a547bb&scoped=true"
import script from "./TarjetaEdicionEmpresa.vue?vue&type=script&lang=js"
export * from "./TarjetaEdicionEmpresa.vue?vue&type=script&lang=js"

import "./TarjetaEdicionEmpresa.vue?vue&type=style&index=0&id=02a547bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a547bb"]])

export default __exports__